module.exports = __webpack_public_path__ + "static/edfen-19620024dd09d870323c318f49709cf9.png";